import document from "@/Apollo/query/promotions/productPromotionPresentation.graphql";
import type {
  ProductPromotionPresentationQuery,
  ProductPromotionPresentationQueryVariables,
} from "@/Apollo/schema";
import { useLanguage } from "@/common/hooks/pages.hooks";
import { PROMOTIONS_ENABLED } from "@/features/promotions/config";
import { usePromotionVisibilityRefresh } from "@/features/promotions/hooks/usePromotionVisibilityRefresh";
import { useQuery } from "@apollo/client";

/** Deliberately separate from the CDN-hydrated product and from delivery measurement. */
export const useProductPromotion = (id: string, slug: string) => {
  const { language } = useLanguage();
  const query = useQuery<
    ProductPromotionPresentationQuery,
    ProductPromotionPresentationQueryVariables
  >(document, {
    variables: { slug, lang: language },
    skip: !PROMOTIONS_ENABLED || !id || !slug,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });
  const visible = usePromotionVisibilityRefresh(
    query.refetch,
    PROMOTIONS_ENABLED && !!id && !!slug
  );
  return visible &&
    !query.loading &&
    !query.error &&
    query.data?.productBySlug?.id === id
    ? query.data.productBySlug.promotion
    : null;
};
